import {
    LOGIN_USER,
    LOGIN_USER_SUCCESS,
    LOGIN_USER_FAILED,
    LOGOUT_USER,
    NOT_AUTHORIZED
} from './constants';

const INIT_STATE = {
    user: null,
    loading: false,
    error: null,
    message: null,
};


const Auth = (state = INIT_STATE, action) => {
    switch (action.type) {
        case LOGIN_USER:
            return { ...state, loading: true };
        case LOGIN_USER_SUCCESS:
            return { ...state, user: action.payload, loading: false, error: null };
        case LOGIN_USER_FAILED:
            return { ...state, error: action.payload, loading: false, message: null };
        case LOGOUT_USER:
            return { ...state, user: null };
        case NOT_AUTHORIZED:
            return { ...state, user: null };
        default:
            return state;
    }
};

export default Auth;
